import { useNavigate } from 'react-router-dom';
import { Grid2 as Grid, Button, Box } from '@mui/material';
import { TitleTextGen } from './';
import { routeKeyPath } from '../utils/constants';

const StartYourJourney = () => {
  const navigate = useNavigate();

  return (
    <TitleTextGen
      title="Start Your Journey"
      text={
        <p>
          Take the first step toward transforming career education at your school.
          <br />
          By starting a Career Club, you’ll gain access to exclusive resources, and inspire your learners to explore and
          achieve their career dreams.
          <br />
          Join the movement today and make a lasting impact on the future of your Learners.
        </p>
      }
      boxProps={{
        sx: {
          boxShadow:'0 0 0 4px rgba(234, 234, 234, 0.4)',
          backgroundColor: 'rgba(234, 234, 234, 0.69)',
        },
      }}
    >
      <Box padding="40px 0">
        <Button
          variant="outlined"
          size="medium"
          onClick={() => {
            navigate('/contact-us');
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          Contact Us
        </Button>
      </Box>
    </TitleTextGen>
  );
};

export default StartYourJourney;
